<template>
  <div class="px-4 pb-4 sm:px-6 sm:pb-6">
    <h1 class="my-2">{{ t("headings.orders") }}</h1>
    <breadcrumb class="mt-3 mb-4" />
    <div class="card">
      <custom-table
        :fields="fields"
        :items="orders"
        :loading="waiting"
        :pagination="true"
        :perPage="10"
        :searchable="true"
        :searchFields="searchFields"
        :showHeader="true"
        sortBy="createdAt"
        :sortFields="sortFields"
        @row-click="(id) => router.push(`/orders/${id}`)"
      >
        <template #cell(createdAt)="{ value }">
          {{ getLocaleDate(locale, value) }}
        </template>
        <template #cell(orderer)="{ value }">
          {{ value.lastName }} {{ value.firstName }}
        </template>
        <template #cell(estate)="{ value }">
          {{ value }}
        </template>
        <template #cell(price)="{ value }">
          {{ value / 100 }}
        </template>
      </custom-table>
    </div>
  </div>
</template>

<script>
import { PlusIcon } from "@heroicons/vue/24/solid";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import Breadcrumb from "../components/breadcrumb/Breadcrumb.vue";
import FormButton from "../components/form/FormButton.vue";
import CustomTable from "../components/table/CustomTable.vue";
import { getLocaleDate } from "../utils/dateUtils";
export default {
  components: { Breadcrumb, CustomTable, FormButton, PlusIcon },
  setup() {
    const router = useRouter();
    const store = useStore();
    const { locale, t } = useI18n();

    const company = computed(() => store.state.company.company);
    const orders = computed(() => store.state.order.orders);

    const fields = ref([
      {
        key: "id",
        label: "id",
      },
      {
        key: "createdAt",
        label: "created_at",
      },
      {
        key: "orderer",
        label: "orderer",
      },
      {
        key: "estate",
        label: "estate_name",
      },
      {
        key: "price",
        label: "price",
      },
    ]);
    const searchFields = ref(["id", "createdAt", "orderer", "estate", "price"]);
    const sortFields = ref(["orderer", "createdAt", "estate", "price"]);

    onMounted(() => {
      store.dispatch("order/getOrders", company.value.id);
    });

    return {
      company,
      fields,
      getLocaleDate,
      locale,
      orders,
      PlusIcon,
      router,
      searchFields,
      sortFields,
      t,
      waiting: computed(() => store.state.order.waiting),
    };
  },
};
</script>
